import { Component, Input, OnInit } from '@angular/core';
import { MessageService } from 'primeng/api';
import { CcLineSummaryDto } from '../../../data/models/cc-line-summary-dto';
import { HatteraslineDto } from '../../../data/models/hatterasline-dto';
import { PairStatusModel } from '../../../data/models/pair-status-model';
import { HatterasService } from '../../../services/hatteras.service';
import { StatusClassService } from '../../../services/status-class.service';

@Component({
  selector: 'app-hatteras-container',
  templateUrl: './hatteras-container.component.html',
  styleUrls: ['./hatteras-container.component.scss']
})
export class HatterasContainerComponent implements OnInit {
  //@Input() ipAddress: string;
  @Input() fullLineInfo: CcLineSummaryDto;
  hatterasLines = new Map<number, PairStatusModel>();
  hatterasLineValuesList: PairStatusModel[] = [];
  constructor(private messageService:MessageService,private hatterasService: HatterasService, private statusClassServcie: StatusClassService) { }

  ngOnInit(): void {
    if (this.fullLineInfo?.ipAddress) {
      this.getHatterasLinesData()
    }
  }

  getHatterasLinesData() {
    this.hatterasService.getHatterasLines(this.fullLineInfo?.ipAddress).subscribe((res: any) => {
      if (res) {
        console.log("test ::   ",res);
        this.hatterasLines = res;
        this.hatterasLineValuesList.push(this.hatterasLines[1]);
        this.hatterasLineValuesList.push(this.hatterasLines[2]);
        this.hatterasLineValuesList.push(this.hatterasLines[3]);
        this.hatterasLineValuesList.push(this.hatterasLines[4]);
        this.hatterasLineValuesList.push(this.hatterasLines[5]);
        this.hatterasLineValuesList.push(this.hatterasLines[6]);
        this.hatterasLineValuesList.push(this.hatterasLines[7]);
        this.hatterasLineValuesList.push(this.hatterasLines[8]);
       
      }
    }, (error) => {
      this.messageService.add({ severity: 'error', summary: 'Get Hatteras Lines Data', detail: 'Could not retrieve Lines of this Hatteras' });
    })
  }

  getViewClass(statusNum) {
    return this.statusClassServcie.getpairStatus(statusNum);

  }
  transform(minutes) {
    const hours = Math.floor(minutes / 60);
    const minutesLeft = minutes % 60;
    return `${hours < 10 ? '0' : ''}${hours} h:${minutesLeft < 10 ? '0' : ''}${minutesLeft} m:00`
  }

}
